module.exports = __webpack_public_path__ + "static/Progressive-90fa43daf098902ddabf7832c8d7f7ff.jpg";